const translations = {
  title: 'Activities',
  'menu.import': 'Import',
  'menu.importHistory': 'Import history',
  'menu.export': 'Export',
  'menu.exportHistory': 'Export history',
  'menu.unproductives': 'Unproductive reasons',
  'menu.disapproves': 'Disapproval reasons',
  'menu.canceled': 'Cancellation reasons',
  'menu.pendencies': 'Pendency reasons',
  'menu.newTrigger': 'Create automation',
  'menu.triggers': 'Automations',
  'menu.integrations': 'Integrations',
  'menu.fields': 'Customize additional fields',
  'menu.tags': 'Activity Tags',
  'menu.templates': 'PDF Templates',
  'menu.templateHistory': 'Document History',
  'counter.text': 'Records found',
  'menu.publicToken': 'Public tokens',
  'menu.semaphore': 'Semaphore configuration',
  'menu.sla': 'Configure SLA',
  'menu.routines': 'Routines',
  'menu.configurations.automatic.distribution': 'Configure automatic distribution',
  'search.normal': 'Normal search',
  'search.reply': 'Search by reply',
  'search.field': 'Search by additional field',
  'search.place': 'Search by destination',
  'table.code': 'Code',
  'table.responsible': 'Responsible',
  'table.destination': 'Destination',
  'table.scheduling': 'Scheduling',
  'table.completion': 'Completion',
  'table.sla': 'SLA',
  'table.status': 'Status',
  'table.priority': 'Priority',
  'table.tag': 'Tag',
  'table.openedAt': 'Opened at',
  'error.unexpected': 'Unexpected error while creating activity'
}

export default translations
